import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChequeRemittanceRoutingModule } from './cheque-remittance-routing.module';
import { ChequeRemittanceDetailsComponent } from './cheque-remittance-details/cheque-remittance-details.component';
import { SharedModule } from '../../../shared/shared.module';
import { ChequeRemittanceCreateComponent } from './cheque-remittance-create/cheque-remittance-create.component';
import { ChequeRemittanceFormContentComponent } from './cheque-remittance-form-content/cheque-remittance-form-content.component';
import { ToLocalTimePipe } from '../../../shared/pipe/local-time/to-local-time.pipe';
import { ChequeRemittanceDetailsAccountMovesComponent } from './cheque-remittance-details/cheque-remittance-details-tab/cheque-remittance-details-account-moves/cheque-remittance-details-account-moves.component';
import { ChequeRemittanceTabsDetailsComponent } from './cheque-remittance-details/cheque-remittance-tabs-details/cheque-remittance-tabs-details.component';
import { ChequeRemittanceListComponent } from './cheque-remittance-list/cheque-remittance-list.component';
import { ChequeRemittanceFormChequesContentComponent } from './cheque-remittance-form-cheques-content/cheque-remittance-form-cheques-content.component';

@NgModule({
  declarations: [
    ChequeRemittanceDetailsComponent,
    ChequeRemittanceCreateComponent,
    ChequeRemittanceFormContentComponent,
    ChequeRemittanceDetailsAccountMovesComponent,
    ChequeRemittanceTabsDetailsComponent,
    ChequeRemittanceListComponent,
    ChequeRemittanceFormChequesContentComponent,
  ],
  imports: [
    CommonModule,
    ChequeRemittanceRoutingModule,
    SharedModule,
    ToLocalTimePipe,
  ],
})
export class ChequeRemittanceModule {}
